module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedString)
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.text.length > _vm.maxChars),
      expression: "text.length > maxChars"
    }]
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadMore),
      expression: "!isReadMore"
    }],
    attrs: {
      "href": _vm.link,
      "id": "readmore"
    },
    on: {
      "click": function($event) {
        return _vm.triggerReadMore($event, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.moreStr))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReadMore),
      expression: "isReadMore"
    }],
    attrs: {
      "href": _vm.link,
      "id": "readmore"
    },
    on: {
      "click": function($event) {
        return _vm.triggerReadMore($event, false)
      }
    }
  }, [_vm._v(_vm._s(_vm.lessStr))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ddc4b48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-read-more/components/ReadMoreComponent.vue
// module id = 2059
// module chunks = 0